module.exports = __webpack_public_path__ + "static/img/figure.08b82e08.png";